// extracted by mini-css-extract-plugin
export default {"FAQBlock":"GiftPage-module--FAQBlock--17093","accordionContainer":"GiftPage-module--accordionContainer--aaab1","h3":"GiftPage-module--h3--1d4a7"};